<template>
  <div id="tryout-group">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Tryout</li>
      <li class="active">Daftar Tryout Group</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Tryout Group</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-success btn-xs" @click="createTryoutGroup()"><span class="fa fa-plus"></span> Tryout Group</button>
            </div>
            <h4 class="panel-title">Tryout Group</h4>
          </div>
          <div class="panel-body">
            <app-datatable
              :items="tryoutGroups"
              :has-action="true"
              :has-custom-pagination="true"
							:has-custom-search="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              :headers="headers"
              v-on:selected="selectedRow = $event"
              v-on:dblClicked="editTryoutGroup()"
              v-on:deleted="deleteTryoutGroup($event)"
              v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
            />
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import DataTable from '@/components/plugins/DataTable'
import TryoutService from '@/services/tryout.js'
import AppSpinner from '@/components/plugins/Spinner'
import Moment from 'moment'

export default {
  name: 'tryout-group',
  components: {
    'app-datatable': DataTable,
    'app-spinner': AppSpinner
  },
  data: function () {
    return {
      tryoutGroups: [],
      selectedRow: null,
      isLoading: false,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc',
      },
      headers: ['Nama', 'Tipe', 'Jenjang', 'Kelas', 'Status', 'Content', 'Created At', 'Join Code'],
      headersKey: ['name', 'type', 'level', 'grade', 'status', 'category', 'createdAt', 'joinCode']  // camel case for matching search with API
    }
  },
  mounted: function () {
    this.fetchData()
  },
  watch: {
    pagination: function () {
      this.fetchData()
    },
  },
  methods: {
    fetchData: function () {
      var context = this
      var search = this.search
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      }

      console.log('search', search)

      TryoutService.getListOfTryoutGroups(pagination, search, null, function (result) {
        context.tryoutGroups = []

        if (result.success) {
          result.data.forEach(function (group) {
            var level = group.level ? group.level : '-'
            var contents = ''

            if (group.tryouts) {
              group.tryouts.forEach(function (tryout) {
                contents += tryout.category + ", "
              })
            }

            var createdAt = Moment(group.created_at).format('YYYY-MM-DD')
            var row = {
              id: group.id,
              data: [
                group.name,
                group.type,
                // group.variant,
                level,
                group.grade == null ? group.grades.toString() : group.grade,
                group.status,
                contents,
                createdAt,
                group.join_code
              ]
            }

            context.pagination.totalPages = group.page
            context.tryoutGroups.push(row)
          })
        }
      })
    },
    createTryoutGroup: function () {
      this.$store.commit('tryout_group_reset')
      this.$router.push({ path: '/tryout-group/form' })
    },
    editTryoutGroup: function () {
      var context = this
      var groupId = this.selectedRow.id
      TryoutService.getTryoutGroup(groupId, function (result) {
        if (result.success) {
          var tryoutGroup = result.data
          context.$store.commit('tryout_group_init', tryoutGroup)
          context.$router.push({ path: '/tryout-group/form', query: { id: groupId } })
        }
      })
    },
    deleteTryoutGroup: function (tryout) {
      var context = this
      var groupId = tryout.id
      var status = tryout.data[3]

      if (status == 'PUBLISHED') {
        window.alert("Tidak dapat menghapus Tryout Group dengan status PUBLISHED")
        return
      }

      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
      if (confirmed) {
        this.isLoading = true
        TryoutService.deleteTryoutGroup(groupId, function (result) {
          if (result.success) {
            var targetIndex = context.tryoutGroups.findIndex(function (group) {
              return group.id == groupId
            })

            context.tryoutGroups.splice(targetIndex, 1)
            context.isLoading = false
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TryoutGroup.vue?65153abd